import { render, staticRenderFns } from "./Callout.vue?vue&type=template&id=15a48b1a&scoped=true&"
import script from "./Callout.vue?vue&type=script&lang=js&"
export * from "./Callout.vue?vue&type=script&lang=js&"
import style0 from "./Callout.vue?vue&type=style&index=0&id=15a48b1a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a48b1a",
  null
  
)

export default component.exports